import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { PurchaseOrder } from '@/interface/store/purchaseOrder';

export const getters: GetterTree<PurchaseOrder, RootState> = {
  getterPoData: (state) => state.poData,
  getterPoAttachment: (state) => state.poAttachments,
};
